// extracted by mini-css-extract-plugin
module.exports = {"repertoire-form":"RepertoireForm_repertoire-form__C4Hws","footer":"RepertoireForm_footer__1AUNA","input":"RepertoireForm_input__2q54n"};